import type { EntityOptions } from 'models';
import { Button, UserSecurityLineIcon } from 'ui';
import { useGetPathToAdminEntitiesList } from './hooks';

export type AdminExtractedEntityType = Extract<
  EntityOptions['entityType'],
  'community' | 'giving' | 'organization' | 'program'
>;

type P = {
  entityType: AdminExtractedEntityType;
};

const AdminConsoleButton = ({ entityType }: P) => {
  const getPathToAdminEntitiesList = useGetPathToAdminEntitiesList();

  return (
    <Button
      icon={<UserSecurityLineIcon />}
      navigate={{ external: true, to: getPathToAdminEntitiesList(entityType) }}
      size="large"
      target="_blank"
    >
      View in Admin Console
    </Button>
  );
};

export default AdminConsoleButton;
